<template>
  <div class="modal-body-content" style="height: 836px; max-height: 100%;">
    <div class="modal-body-list-box">
      <div class="search-box-in-title" style="padding-right: 24px; margin-top: 20px;">
        <h2 :title="$t('change_marker_grouping_interval')" style="padding-left: 4px;">{{ $t('change_marker_grouping_interval') }}</h2>
        <div class="button-group" style="width: 106px;">
          <button class="action-button" style="cursor: pointer;" @click="changeMarkerGroupInterval">{{ $t('save') }}</button>
        </div>
      </div>
      <div class="slider-box">
        <input type="range" id="distance" v-model="distance" min="0" max="1000" step="1"/>
        <h3 style="display: flex; align-items: center;">
          <input type="number" v-model="distance" id="distance-input" min="0" max="1000" step="1"/>m
        </h3>
      </div>
      <div id="settingMap" style="height: 100%; width: calc(100% - 48px); border-radius: 10px; margin-bottom: 20px;"></div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue';
import L from 'leaflet';
import { CalculateCircleBoundary, defaultLocation, firstMapSetting, getMarkerGroupingRange } from '@/utils/MapSetting';
import { Modify_Setting } from '@/utils/Setting';

const distance = ref(getMarkerGroupingRange());
const settingMap = ref(null);
let polygonLayer;
//#region 마커 그룹화 간격 변경
const viewCircle = () => {
  if (polygonLayer) settingMap.value.removeLayer(polygonLayer); // 기존 폴리곤이 있다면 삭제
  polygonLayer = L.circle(defaultLocation.value, { radius: distance.value, color: 'blue', fillOpacity: 0.2, type: "polygon" }).addTo(settingMap.value);

  // 경계 박스 생성 후 fitBounds 적용
  const bounds = CalculateCircleBoundary(defaultLocation.value[0], defaultLocation.value[1], distance.value)
  settingMap.value.fitBounds(bounds, { padding: [20, 20] }); // 약간의 여백 추가
}
watch([distance], viewCircle);
const changeMarkerGroupInterval = () => {
  Modify_Setting('marker_grouping_range', distance.value);
};
onMounted(() => {
  nextTick(async () => {
    settingMap.value = await firstMapSetting('settingMap', 17);
    viewCircle();
  });
});
//#endregion
</script>